import React from 'react';
import { useLang } from '../../i18n/LanguageContext';
import Reveal from '../layout/Reveal';
import { IMG } from '../../data/media';

export function FounderStory() {
  const { t } = useLang();
  return (
    <section id="founder" className="py-20 sm:py-24 bg-cream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-[0.9fr_1.1fr] gap-12 md:gap-16 items-center">
        <Reveal className="relative max-w-sm w-full mx-auto">
          <img src={IMG.founder} alt={t('phFounder')} loading="lazy" decoding="async" className="w-full aspect-[4/5] object-cover rounded-[2rem] shadow-xl" />
          <div className="absolute -bottom-5 -right-3 bg-white rounded-2xl shadow-xl px-5 py-3">
            <div className="text-3xl font-extrabold text-saffron"><span data-count="20">0</span>+</div>
            <div className="text-xs text-slate-500">{t('yrsIns')}</div>
          </div>
        </Reveal>
        <Reveal>
          <p className="kicker text-saffron">{t('fKick')}</p>
          <div className="text-7xl leading-none text-saffron/30 font-serif -mb-6" aria-hidden="true">“</div>
          <blockquote className="text-2xl sm:text-3xl font-semibold leading-snug">{t('fQuote')}</blockquote>
          <p className="mt-5 text-slate-600 leading-relaxed">{t('fText')}</p>
          <div className="mt-6 text-4xl font-sign text-ink">Tusar Kumar Bera</div>
          <div className="text-sm text-slate-500">{t('fRole')}</div>
        </Reveal>
      </div>
    </section>
  );
}

const STEP_COLORS = ['text-brand', 'text-saffron', 'text-emerald-600'];

export function HowWeWork() {
  const { t } = useLang();
  return (
    <section className="py-20 sm:py-24 bg-sky">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center max-w-2xl mx-auto mb-14"><p className="kicker text-brand">{t('hKick')}</p><h2 className="h2">{t('hTitle')}</h2></Reveal>
        <Reveal className="relative grid md:grid-cols-3 gap-10 md:gap-8 group/steps">
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-[3px] rounded bg-gradient-to-r from-brand via-saffron to-emerald-500 origin-left scale-x-0 transition-transform duration-[1400ms] delay-200 [.in_&]:scale-x-100" />
          {[1, 2, 3].map((n, i) => (
            <div key={n} className="relative text-center">
              <div className={`mx-auto w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center text-xl font-extrabold ring-4 ring-sky ${STEP_COLORS[i]}`}>0{n}</div>
              <h3 className="mt-5 font-bold text-lg">{t(`s${n}t`)}</h3>
              <p className="mt-2 text-slate-600 max-w-xs mx-auto">{t(`s${n}p`)}</p>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
